// Dependencies
import React from 'react';
import radium from 'radium';
import ButtonEventsOverview from '../../../components/button-events-overview/ButtonEventsOverview.jsx';
import ShoppingCartImage from './ShoppingCartImage.jsx';
import {ThemeContext} from '../../../components/theme/Theme.jsx';
import {connect} from "react-redux";
import Button from "../../../components/button/Button.js";
import {navigateToEntranceIfGiven} from "../../../lib/nav-util-service.js";

function EmptyShoppingCart(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			flexGrow: '1',
			display: 'flex',
			flexDirection: 'column',
		},
		headline: {
			fontSize: context.themeManager.value('shopping-cart', 'headlineFontSize', 'font-size-500'),
			fontWeight: '300',
			textAlign: 'center',
			margin: '0 0 1em',
		},
		subHeadline: {
			fontSize: context.themeManager.value('shopping-cart', 'subHeadlineFontSize', 'font-size-250'),
			fontWeight: '300',
			textAlign: 'center',
			margin: '0 0 0.5em',
		},
		buttonContainer: {
			marginTop: '2em',
			marginBottom: '3em',
		},
	};
	return (
		<div style={style.container}>
			<ShoppingCartImage/>
			<h1 style={style.headline}>
				Ihr Warenkorb ist leer.
			</h1>
			<h2 style={style.subHeadline}>
				Es befinden sich noch keine Tickets in Ihrem Warenkorb.
			</h2>
			<div style={style.buttonContainer}>
				{!props.entranceUrl &&
					<ButtonEventsOverview
						btnText={context.themeManager.getThemeTextOrHardcodedDefault('goToEventOverviewBtnLabel')}
						iconName="angle-double-left"
					/>
					||
					<Button
						name="to_startpage"
						buttonText="Zur Startseite"
						btnStyle="highlight"
						onClick={() => navigateToEntranceIfGiven(props.eventUuid)}
					/>
				}
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		eventUuid: state.event.selected,
		entranceUrl: state.sponsorCodes.excludePublicSeats
	};
};

const RadiumEmptyShoppingCart = radium(EmptyShoppingCart);

export default connect(
	mapStateToProps,
)(RadiumEmptyShoppingCart);
